export default __webpack_public_path__ + "static/media/painoient.ad57d5af.jpeg";